import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './SuccessScreen.css';

function SuccessScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectTimerRef = useRef(null);

  useEffect(() => {
    // Auto-redirect after 4 seconds
    // In React 18 StrictMode (dev), effects are mounted/cleaned up/mounted again.
    // We guard against multiple timers, but allow re-scheduling after cleanup.
    if (redirectTimerRef.current) return;
    redirectTimerRef.current = setTimeout(() => {
      navigate('/whatsapp', { replace: true });
    }, 4000);

    return () => {
      if (redirectTimerRef.current) {
        clearTimeout(redirectTimerRef.current);
        redirectTimerRef.current = null;
      }
    };
  }, [navigate]);

  const handleGoToWhatsApp = (e) => {
    // Never let this button behave like a submit button (prevents full page reloads).
    e?.preventDefault?.();
    // If user clicks manually, cancel the pending auto-redirect to avoid double navigation.
    if (redirectTimerRef.current) {
      clearTimeout(redirectTimerRef.current);
      redirectTimerRef.current = null;
    }
    navigate('/whatsapp', { replace: true });
  };

  return (
    <div className="success-screen">
      <div className="success-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h2>{t('onboarding.success.title')}</h2>
      <p>{t('onboarding.success.message')}</p>
      <button type="button" onClick={handleGoToWhatsApp} className="whatsapp-button">
        {t('onboarding.success.whatsapp_button')}
      </button>
      <p className="redirect-message">{t('onboarding.success.redirect_message')}</p>
    </div>
  );
}

export default SuccessScreen;

